import { useState } from "react";
import { EventResponse } from "types/Post";

/**
 * Sends an answer to an event one at a time: `isSaving` is true until the request ends, so a
 * second click cannot start another. `respond` reports a failed request itself.
 */
export function useEventAnswer(respond: (response: EventResponse | null) => Promise<void>) {
  const [isSaving, setIsSaving] = useState(false);

  const answer = async (response: EventResponse | null) => {
    setIsSaving(true);
    try {
      await respond(response);
    } finally {
      setIsSaving(false);
    }
  };

  return { isSaving, answer };
}
